import React, { useEffect, useState } from "react";
import { homeClasses } from "./styles";
import {
  Box,
  Container,
  FormControl,
  MenuItem,
  Select,
  Typography,
  useScrollTrigger,
} from "@mui/material";
import BgImg from "../../assets/images/bg.jpg";
import Topbar from "../../components/Topbar/Topbar";
import { SPColor } from "../../constants/color";
import MiniCard from "../../components/MiniCard/MiniCard";
import SPSelect from "../../components/SPSelect/SPSelect";
import {
  CityOverviewType,
  RecordType,
  School,
  SchoolLeader,
} from "../../types/record";
import CityOverview from "../../components/CircleProgress/CityOverview";
import Footer from "../../components/Footer/Footer";
import LeaderBoard from "../../components/LeaderBoard/LeaderBoard";
import ClassLeader from "../../components/LeaderBoard/GradeLeader";
import SchoolLeaderPage from "../../components/LeaderBoard/SchoolLeaderPage";
import GradeLeader from "../../components/LeaderBoard/GradeLeader";
import { SelectItem } from "../../types/global";

const gradeList: SelectItem[] = [
  { value: 7, label: `תחרות בין הכיתות בשכבה ז'` }
  ];

const videos = [
  "7241093621217316097",
  "7241095130810174728",
  "7241834298779766017",
  //SP230623: replace stale video
  "7243712432806415617",
  // "7241110744576658689",

  // "https://www.tiktok.com/@speakingpal/video/7241093621217316097",
  // "https://www.tiktok.com/@speakingpal/video/7241095130810174728",
  // "https://www.tiktok.com/@speakingpal/video/7241834298779766017",
  // "https://www.tiktok.com/@speakingpal/video/7241110744576658689",
];

export default function Home() {
  const classes = homeClasses;
  const [loading, setLoading] = useState<boolean>(false);
  const [schools, setSchools] = useState<School[]>([]);
  const [cityOverview, setCityOverview] = useState<CityOverviewType | null>(
    null
  );
  const [schoolLeaderList, setSchoolLeaderList] = useState<SchoolLeader[]>([]);
  const [classlLeaderList, setClasslLeaderList] = useState<SchoolLeader[]>([]);

  const [schoolId, setSchoolId] = useState<string | number>("");
  const [schoolLeader, setSchoolLeader] = useState<
    SchoolLeader | null | undefined
  >(null);

  const [trigger, setTrigger] = useState<boolean>(false);

  const getDeviceConfig = (width: number) => {
    if (width < 320) {
      return "xs";
    } else if (width >= 320 && width < 720) {
      return "sm";
    } else if (width >= 720 && width < 1024) {
      return "md";
    } else if (width >= 1024) {
      return "lg";
    }
  };

  const [brkPnt, setBrkPnt] = useState(() =>
    getDeviceConfig(window.innerWidth)
  );

  useEffect(() => {
    window.addEventListener("resize", function () {
      setBrkPnt(getDeviceConfig(window.innerWidth));
    });
  });

  const [tiktokUrl, setTiktokUrl] = useState<string>("");

  console.log("brkPnt =>> ", brkPnt);

  // const scrollTrigger = useScrollTrigger({
  //   threshold: $(window).height() - 70,
  // });

  // useEffect(() => {
  //   setTrigger(scrollTrigger);
  // }, [scrollTrigger]);

  const [page, setPage] = useState<string>("home");
  const [grade, setGrade] = useState<number | null>(null);

  const handleScroll = () => {
    const position = window.pageYOffset;

    const basePosition =
      getDeviceConfig(window.innerWidth) === "sm" ? 125 : 170;
    if (position > basePosition) {
      setTrigger(true);
    } else {
      setTrigger(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/school-list`)
      .then((response) => response.json())
      .then((data) => {
        const schoolList = JSON.parse(data.school_list);
        setSchools(schoolList);
        setCityOverview(JSON.parse(data.city_overview));
        setSchoolLeaderList(JSON.parse(data.school_leader_board));
        setLoading(false);
      });

    window.addEventListener("scroll", handleScroll, { passive: true });

    const generateRandom = () => {
      const maxNum = Date.now() % 4;
      return videos[maxNum];
    };

    setTiktokUrl(generateRandom());

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleSelectSchool = (e: string | number) => {
    setGrade(null);
    setSchoolId(e);
    const leader = schoolLeaderList.find(
      (item: SchoolLeader) => item.id.toString() === e.toString()
    );
    setSchoolLeader(leader);
  };

  const handleSelectGrade = (e: number) => {
    setSchoolId("");
    setGrade(e);
  };

  const openSelectList = (type: string) => {
    console.log("type", type);
    setPage(type);
  };

  const handleClickCard = (type: string) => {
    if (type === "home") {
      setSchoolId("");
      setGrade(null);
      setPage(type);
    }
  };

  const MiniCardGroups = () => (
    <Box
      sx={{
        ...classes.cardList,
        marginTop: { md: "38.5px", xs: 1 },
        zIndex: 100,
      }}
    >
      <MiniCard
        bgColor={SPColor.ORANGE}
        onClick={() => openSelectList("school")}
        sx={{
          ...classes.miniCard,
          border:
            page === "school"
              ? "solid 3px " + SPColor.WHITE
              : "solid 1px " + SPColor.DARK_BLUE,
        }}
      >
        <Typography
          component={"h5"}
          variant="h5"
          color={SPColor.WHITE}
          sx={{ fontSize: { xs: "1.3rem", md: "1.5rem" } }}
          fontWeight={page === "school" ? "bold" : 400}
        >
          מבט בית ספרי
        </Typography>
        {/* <Box sx={{ marginTop: 1, padding: 1 }}>
          <SPSelect
            items={schools.map((item) => ({
              label: item.name,
              value: item.id,
            }))}
            onChange={(e: number | string) => handleSelectSchool(e)}
            defaultValue={schoolId}
            size="small"
            bgColor={SPColor.WHITE}
            sx={{
              borderColor: "black",
              minWidth: { xl: "150px", xs: "15%" },
            }}
            placeholder="Select School"
            name={"school"}
          />
        </Box> */}
      </MiniCard>
      <MiniCard
        bgColor={SPColor.GREEN}
        sx={{
          marginLeft: 2,
          ...classes.miniCard,
          border:
            page === "grade"
              ? "solid 3px " + SPColor.WHITE
              : "solid 1px " + SPColor.DARK_BLUE,
        }}
        onClick={() => openSelectList("grade")}
      >
        <Typography
          component={"h5"}
          variant="h5"
          color={SPColor.WHITE}
          sx={{ fontSize: { xs: "1.3rem", md: "1.5rem" } }}
          fontWeight={page === "grade" ? "bold" : 400}
        >
          תחרות שכבתית
        </Typography>
      </MiniCard>
      <MiniCard
        bgColor={SPColor.LIGHT_BLUE}
        sx={{
          ...classes.miniCard,
          marginLeft: 2,
          border:
            page === "home"
              ? "solid 3px " + SPColor.WHITE
              : "solid 1px " + SPColor.DARK_BLUE,
        }}
        onClick={() => handleClickCard("home")}
      >
        <Typography
          component={"h5"}
          variant="h5"
          color={SPColor.WHITE}
          sx={{ fontSize: { xs: "1.3rem", md: "1.5rem" } }}
          fontWeight={page === "home" ? "bold" : 400}
        >
          מבט כללי
        </Typography>
      </MiniCard>
    </Box>
  );

  return (
    <>
      <Box
        sx={{
          ...classes.banner,
          backgroundImage: `url(${BgImg})`,
          zIndex: 100,
        }}
        position={trigger ? "fixed" : "initial"}
        marginTop={{ md: trigger ? "-172px" : 0, xs: trigger ? "-128px" : 0 }}
        // marginTop={trigger ? "-172px !important" : "0"}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Topbar />
        </div>
        <Box sx={classes.bannerBody}>
          <Box sx={{ marginTop: { md: "-30.5px", xs: 0 } }}>
            <Typography
              component={"h3"}
              variant="h3"
              color={SPColor.WHITE}
              sx={{ fontSize: { xs: "2rem", md: "3.5rem" } }}
            >
              בית ספר טהא חוסין סכנין מדבר אנגלית
            </Typography>
            <Typography
              component={"h4"}
              variant="h4"
              color={SPColor.WHITE}
              sx={{ fontSize: { xs: "1.3rem", md: "1.8rem" } }}
            >
            תשפ״ה 2025
            </Typography>
          </Box>
          {MiniCardGroups()}
        </Box>
      </Box>

      <Box marginTop={{ md: trigger ? "312px" : 2, xs: trigger ? "275px" : 2 }}>
        <Box
          minHeight={{ md: "calc(100vh - 451px)", xs: "calc(100vh - 411px)" }}
          sx={{
            maxWidth: { xl: "lg", ls: "sm" },
            margin: "auto",
            // paddingX: '2px',
          }}
          marginTop={trigger ? "362px" : "50px"}
        >
          {(!!!page || page === "home") && (
            <CityOverview cityOverview={cityOverview} tiktokUrl={tiktokUrl} />
          )}
          {page === "school" && <SchoolLeaderPage schools={schools} />}
          {page === "grade" && <GradeLeader gradeList={gradeList} />}
        </Box>
        <Footer />
      </Box>
    </>
  );
}
